import React from "react";
import Help from "../../../../commonComponents/help";


export default function ViewHelpExpandedColumn(props) {
    return <Help data={props.data}/>
}